import {
  FocusClass,
  HashLinkFix,
  initializer,
  JSAttr,
  LazyLoad,
  LIGHTBOX_CONTROLLER_ID,
  Toggle,
} from 'js-common';

import { INTRO_CONTROLLER_ID, IMAGE_SLIDER_CONTROLLER_ID } from './constants';
import Menu from './Menu';

initializer.register([
  FocusClass,
  HashLinkFix,
  JSAttr,
  Toggle,
  Menu,
  LazyLoad,
  [
    INTRO_CONTROLLER_ID,
    () => import(/* webpackChunkName: 'Intro' */ './Intro'),
  ],
  [
    IMAGE_SLIDER_CONTROLLER_ID,
    () => import(/* webpackChunkName: 'ImageSlider' */ './ImageSlider'),
  ],
  [
    LIGHTBOX_CONTROLLER_ID,
    () => import(/* webpackChunkName: 'Lightbox' */ 'js-common/Lightbox'),
  ],
]);
initializer.init();
